import { render, staticRenderFns } from "./BranchList.vue?vue&type=template&id=56d12086&scoped=true"
import script from "./BranchList.vue?vue&type=script&lang=js"
export * from "./BranchList.vue?vue&type=script&lang=js"
import style0 from "./BranchList.vue?vue&type=style&index=0&id=56d12086&prod&lang=scss&scoped=true"
import style1 from "./BranchList.vue?vue&type=style&index=1&id=56d12086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d12086",
  null
  
)

export default component.exports